<template>
  <div>
    <b-modal
      ref="modal-settings-homework-status"
      :title="
        dataType.type == 'create'
          ? $t('New homework status')
          : $t('Edit homework status')
      "
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
    >
      <ValidationObserver ref="form-settings-homework-status">
        <div>
          <b-row class="border-right">
            <!-- Abrevisions -->
            <b-col md="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="abrevision"
                rules="required"
              >
                <b-form-group
                  :label="$t('Abbreviation')"
                  label-for="abbreviation"
                >
                  <b-form-input
                    id="abbreviation"
                    :state="errors[0] ? false : null"
                    v-model="newHomeworkStatus.abbreviation"
                    type="text"
                    v-mask="'XXX'"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Description -->
            <b-col :md="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="description"
                rules="required"
              >
                <b-form-group
                  :label="$t('description')"
                  label-for="description"
                >
                  <b-form-input
                    id="description"
                    :state="errors[0] ? false : null"
                    v-model="newHomeworkStatus.description"
                    type="text"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Viatic -->
            <b-col md="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="viatic_status"
                rules="required"
              >
                <b-form-group
                  :label="$t('Viatic Status')"
                  label-for="viatic_status"
                  :state="errors[0] ? false : null"
                >
                  <v-select
                    id="viatic_status"
                    v-model="newHomeworkStatus.viatic_status"
                    :options="viaticStatus"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Cost Center -->
            <b-col md="6" v-if="newHomeworkStatus.viatic_status == 1">
              <ValidationProvider
                v-slot="{ errors }"
                name="viatic_cost"
                rules="required"
              >
                <b-form-group
                  :label="$t('Viatic Cost')"
                  label-for="viatic_cost"
                  :state="errors[0] ? false : null"
                >
                  <b-form-input
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="newHomeworkStatus.viatic_cost"
                    type="text"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Payroll Apply -->
            <b-col md="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="payroll_apply"
                rules="required"
              >
                <b-form-group
                  :label="$t('Payroll Apply')"
                  label-for="payroll_apply"
                  :state="errors[0] ? false : null"
                >
                  <v-select
                    id="payroll_apply"
                    v-model="newHomeworkStatus.payroll_apply"
                    :options="payrollOptions"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
      </ValidationObserver>
      <!-- Modal footer -->
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="hideModal"
                variant="outline-danger"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button variant="outline-primary" @click="saveHomeworkStatuses">
                {{ dataType.type == "create" ? $t("SAVE") : $t("UPDATE") }}
              </b-button>
            </b-col>
          </b-row>
          <!-- <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader> -->
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeworkStatusService from "@/views/settings/views/homework-status/service/homework-status.service";

// import  DotLoader from 'vue-spinner/src/DotLoader.vue'
export default {
  components: {},
  props: {
    dataType: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      newHomeworkStatus: {
        status: "",
        abbreviation: "",
        description: "",
        viatic_cost: "",
        viatic_status: "",
        payroll_apply: "",
      },
      viaticStatus: [
        { id: 1, label: "Apply" },
        { id: 2, label: "Not Apply" },
      ],
      payrollOptions: [
        { id: 1, label: "Yes" },
        { id: 2, label: "No" },
      ],
      status: [
        { id: 1, label: "Active" },
        { id: 2, label: "Inactive" },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {
    if (this.dataType.type == "edit") {
      this.newHomeworkStatus.abbreviation = this.dataType.data.abbreviation;
      this.newHomeworkStatus.description = this.dataType.data.description;
      this.newHomeworkStatus.viatic_status =
        this.dataType.data.viatic_status == "Apply" ? 1 : 2;
      this.newHomeworkStatus.status = this.dataType.data.status;
      this.newHomeworkStatus.viatic_cost = this.dataType.data.viatic_cost;
      this.newHomeworkStatus.payroll_apply = this.dataType.data.payroll_apply;
    }
  },
  methods: {
    async saveHomeworkStatuses() {
      try {
        const isValidate = await this.$refs[
          "form-settings-homework-status"
        ].validate();
        if (isValidate) {
          let params = {
            status: 1, // Active
            abbreviation: this.newHomeworkStatus.abbreviation,
            description: this.newHomeworkStatus.description,
            viatic_cost:
              this.newHomeworkStatus.viatic_status == 1
                ? this.newHomeworkStatus.viatic_cost
                : null,
            viatic_status: this.newHomeworkStatus.viatic_status,
            payroll_apply: this.newHomeworkStatus.payroll_apply,
            created_by: this.currentUser.id,
          };
          this.addPreloader();
          if (this.dataType.type == "create") {
            await HomeworkStatusService.setHomeworkStatus(params);
            this.$emit("refresh");
          } else {
            params = { ...params, id: this.dataType.data.id };
            await HomeworkStatusService.updateHomeworkStatus(params);
            this.$emit("refresh");
          }
        }
      } catch (error) {
        console.log(error);
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    hideModal() {
      this.$emit("hideModal");
    },
  },
  mounted() {
    this.toggleModal("modal-settings-homework-status");
  },
};
</script>

<style></style>
